import { render, staticRenderFns } from "./EzDistributorUserModal.vue?vue&type=template&id=ebb54b1a&scoped=true&"
import script from "./EzDistributorUserModal.vue?vue&type=script&lang=js&"
export * from "./EzDistributorUserModal.vue?vue&type=script&lang=js&"
import style0 from "./EzDistributorUserModal.vue?vue&type=style&index=0&id=ebb54b1a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb54b1a",
  null
  
)

export default component.exports